/* eslint-disable @typescript-eslint/no-explicit-any */

import { VAN_HOA_EMAIL_TEMPLATE_PAGES } from '@/config/vanHoaEmailTemplatePageConfig';

const VAN_HOA_EMAIL_TEMPLATE_ROUTE_MAP = Object.fromEntries(
  Object.keys(VAN_HOA_EMAIL_TEMPLATE_PAGES).map((path) => [
    `van-hoa/cau-hinh-email/mau-mail/${path}`,
    'cauhinh',
  ]),
);

/**
 * Kiểm tra quyền truy cập route
 * @param routeRole - Role yêu cầu của route
 * @param userRole - Role của user
 * @returns true nếu user có quyền, false nếu không
 */
export const checkPermission = (routeRole: any, userRole: any): boolean => {
  if (!routeRole || !userRole) {
    return true;
  }

  // User có nhiều roles, route chỉ có 1 role
  if (userRole && Array.isArray(userRole) && !Array.isArray(routeRole)) {
    return userRole.indexOf(routeRole) >= 0;
  }

  // Route không yêu cầu role nào
  if (routeRole.length === 0) {
    return !userRole || userRole.length === 0;
  }

  // Cả user và route đều có nhiều roles
  if (userRole && Array.isArray(userRole) && Array.isArray(routeRole)) {
    return routeRole.some((r) => userRole.indexOf(r) >= 0);
  }

  // User có 1 role, route có 1 role
  return routeRole.indexOf(userRole) >= 0;
};

/**
 * Bản đồ ánh xạ ROUTE_TO_CONTROLLER_MAP
 * -------------------------------------
 * Dùng để chuyển đổi route (đường dẫn frontend) sang controller (tên controller backend)
 *
 * @example
 *   'buoc1' => 'buoc1'
 *   'to-chuc/nhan-vien' => 'nhanvien'
 *
 * ROUTE(FE) -> CONTROLLER(BE)
 */
export const ROUTE_TO_CONTROLLER_MAP: Record<string, string> = {
  // ==================== Dashboard ====================
  '': 'dashboard',
  'dashboard': 'dashboard',
  'dashboard-kpi-thuong': 'dashboard',
  'dot-on-tap': 'dotontap',
  'dot-on-tap/ket-qua': 'dotontap',
  'van-hoa/dot-on-tap': 'vanhoa_dotontap',
  'van-hoa/dot-on-tap/ket-qua': 'vanhoa_dotontap',
  'van-hoa/quan-ly-khoa-hoc': 'quan-ly-khoa-hoc',
  'van-hoa/bang-ke-hoach': 'vanhoa_bangkehoach',
  'van-hoa/xuong-ca-ke-hoach': 'vanhoa_bangkehoach',
  'van-hoa/danh-gia': 'vanhoa_danhgia',
  'van-hoa/timeline': 'vanhoa_timeline',
  'van-hoa/du-an': 'vanhoa_actionplan',
  'van-hoa/cong-viec-du-an': 'vanhoa_actionplan',
  'van-hoa/quan-ly-action-plan-bo-phan': 'vanhoa_actionplan',
  'van-hoa/dot-danh-gia': 'vanhoa_dotkhaosat',
  'van-hoa/to-chuc/bo-phan': 'bophan',
  'van-hoa/to-chuc/chuc-vu': 'chucvu',
  'van-hoa/to-chuc/nhan-vien': 'nhanvien',
  'van-hoa/to-chuc/khoa-dang-nhap': 'nhanvien',
  'van-hoa/cau-hinh': 'cauhinh',
  'van-hoa/role-group': 'nhomquyen',
  'bang-ke-hoach': 'bangkehoach',

  // ==================== Triển khai BSC ====================
  // Bước 1: Đánh giá
  'danh-gia': 'buoc1',
  'buoc1': 'buoc1',

  // Bước 2: Xây dựng chiến lược
  'buoc2': 'buoc2ngoinha',
  'xay-dung-chien-luoc/swot': 'buoc2swot',
  'xay-dung-chien-luoc/chien-luoc': 'buoc2chienluoc',
  'buoc2swot': 'buoc2swot',
  'buoc2chienluoc': 'buoc2chienluoc',

  // Bước 3: Kết quả chiến lược
  'b3-ket-qua-chien-luoc': 'buoc3',
  'buoc3': 'buoc3',
  'ket-qua-chien-luoc/lua-chon': 'buoc3',
  'ket-qua-chien-luoc/ket-qua': 'buoc3',

  // Bước 4: Bản đồ chiến lược
  'ban-do-chien-luoc-thanh-phan': 'buoc4thanhphan',
  'ban-do-chien-luoc': 'buoc4',
  'buoc4thanhphan': 'buoc4thanhphan',
  'buoc4': 'buoc4',

  // Bước 5
  'buoc5': 'buoc5',

  // Bước 6
  'buoc6': 'buoc6',
  'buoc6/chi-tieu-cha-con': 'buoc6',

  // Bước 7: Phân bổ tỷ trọng
  'phan-bo-ti-trong': 'buoc7',
  'buoc7': 'buoc7',
  'buoc-7-ti-trong-thu-cong': 'buoc7thucong',

  // Bước 9: Action plan
  'du-an': 'buoc9',
  'action-plan-v2': 'buoc9',
  'action-plan': 'buoc9',
  'cong-viec-du-an': 'buoc9',
  'buoc9': 'buoc9',
    'b9-phong-cach-van-hoa': 'vanhoa_dotontap',
    'quan-ly-action-plan-bo-phan': 'quanlyactionplanbophan',
    'tong-quan-cong-viec': 'tongquancongviec',
    // V2 cùng quyền Action Plan (API load-tong-quan-cong-viec V2 kiểm `buoc9`) — nhân viên có buoc9 không bị chặn trang.
    'tong-quan-cong-viec-v2': 'buoc9',

  // ==================== Họp tuần ====================
  // Menu modulename = hoptuan
  'hop-tuan': 'hoptuan',

  // ==================== Báo cáo ====================
  'bao-cao-kpis': 'buoc11',
  'report-kpi-from-api': 'report-kpi-from-api',
  // Không có module 'bao-cao-nhanh' trong RoleModule — đi chung quyền với Báo cáo KPIs (Layout: buoc11 → buoc6).
  'bao-cao-nhanh': 'buoc11',
  'thong-ke-bao-cao-kpis': 'buoc11dashboard',
  'thong-ke-kpi-khong-dat': 'dashboard',
  'tong-hop-ca-nhan': 'buoc15',
  'bao-cao-bsc': 'baocaobsc',
  'bao-cao-chi-tiet-bsc': 'baocaobsc',

  // ==================== Thiết lập ====================
  // Tổ chức
  'to-chuc/bo-phan': 'bophan',
  'to-chuc/chuc-vu': 'chucvu',
  'to-chuc/nhan-vien': 'nhanvien',
  'to-chuc/khoa-dang-nhap': 'nhanvien',
  'to-chuc/nghi-phep': 'nghidaihan',
  'quy-trinh/so-do-to-chuc': 'chucvu',
  'quy-trinh/ai-rules': 'buoc2ngoinha',
  'thiet-lap/ai-agent': 'cauhinh',
  'thiet-lap/ai-agent/cai-dat': 'cauhinh',
  'thiet-lap/ai-agent/chat': 'cauhinh',
  'thiet-lap/ai-agent/agents': 'cauhinh',
  'thiet-lap/ai-agent/prompt': 'cauhinh',
  'thiet-lap/ai-agent/knowledge': 'cauhinh',
  'thiet-lap/ai-agent/templates': 'cauhinh',
  'thiet-lap/ai-agent/tich-hop': 'cauhinh',
  'thiet-lap/ai-agent/mcp': 'cauhinh',

  // API sync / whitelist / languages / license (khớp modulename menu)
  'thiet-lap/api-sync-data': 'apiurl',
  'van-hoa/thiet-lap/api-sync-data': 'apiurl',
  'thiet-lap/api-co-cau': 'apisyncurl',
  'van-hoa/thiet-lap/api-co-cau': 'apisyncurl',
  'thiet-lap/api-co-cau/thong-bao': 'apisyncurl',
  'van-hoa/thiet-lap/api-co-cau/thong-bao': 'apisyncurl',
  'thiet-lap/api-url-whitelist': 'apiurlwhitelist',
  'thiet-lap/languages': 'languages',
  'van-hoa/thiet-lap/languages': 'languages',
  'thiet-lap/license': 'license',
  'thiet-lap/resources': 'resources',
  'database': 'database',
  'cau-hinh-chung': 'cauhinh',
  'cau-hinh': 'cauhinh',

  // Cấu hình
  'thiet-lap/cau-hinh': 'cauhinh',
  'thiet-lap/thong-bao-he-thong': 'cauhinh',
  'cau-hinh-email': 'cauhinh',
  'cau-hinh-email/thoi-gian-gui-mail': 'cauhinh',
  'van-hoa/email-logs': 'cauhinh',
  'quy-trinh/email-logs': 'cauhinh',
  'van-hoa/cau-hinh-email/thoi-gian-gui-mail': 'cauhinh',
  // Trang thời gian gửi mail phân hệ Quy trình — permission controller = cauhinh (cùng SMTP/template).
  'quy-trinh/cau-hinh-email/thoi-gian-gui-mail': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail': 'cauhinh',
  'van-hoa/cau-hinh-email/cau-hinh-smtp': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khoi-phuc-mat-khau': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/xac-nhan-khoi-phuc': 'cauhinh',
  'quy-trinh/cau-hinh-email/cau-hinh-smtp': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/khoi-phuc-mat-khau': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/xac-nhan-khoi-phuc': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/thong-bao-quy-trinh': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/thong-bao-xu-ly-lai-quy-trinh': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/thong-bao-hoan-thanh-quy-trinh': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/thong-bao-leo-thang-quy-trinh': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/moi-tham-gia-khao-sat': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/bat-dau-khao-sat': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/hoan-thanh-khao-sat': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/chua-hoan-thanh-khao-sat': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/nhac-nho-khao-sat-lan-1': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/nhac-nho-khao-sat-lan-2': 'cauhinh',
  'quy-trinh/cau-hinh-email/mau-mail/nhac-nho-khao-sat-lan-3': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/mau-nhap-bao-cao': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/danh-gia-van-hoa-hien-tai-tuong-lai/lam-bai-khao-sat': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/danh-gia-van-hoa-hien-tai-tuong-lai/ket-thuc': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/dao-tao-bsc/bat-dau-hoc': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/dao-tao-bsc/ket-thuc-hoc': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khao-sat-van-hoa/lam-bai-khao-sat': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khao-sat-van-hoa/nhac-lan-1': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khao-sat-van-hoa/nhac-lan-2': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khao-sat-van-hoa/nhac-lan-3': 'cauhinh',
  'van-hoa/cau-hinh-email/mau-mail/khao-sat-van-hoa/ket-thuc': 'cauhinh',
  ...VAN_HOA_EMAIL_TEMPLATE_ROUTE_MAP,
  'cau-hinh-email/mau-mail/yeu-cau-bao-cao-kpis': 'cauhinh',
  'cau-hinh-email/mau-mail/dang-ky-thanh-vien-moi': 'cauhinh',
  'cau-hinh-email/mau-mail/khoi-phuc-mat-khau': 'cauhinh',
  'cau-hinh-email/mau-mail/xac-nhan-khoi-phuc': 'cauhinh',
  'cau-hinh-email/mau-mail/bang-ke-hoach/bat-dau': 'cauhinh',
  'cau-hinh-email/mau-mail/bang-ke-hoach/ket-thuc': 'cauhinh',
  'cau-hinh-email/mau-mail/action-plan/bat-dau': 'cauhinh',
  'cau-hinh-email/mau-mail/action-plan/ket-thuc': 'cauhinh',
  'cau-hinh-email/mau-mail/action-plan/bao-cao': 'cauhinh',
  'thiet-lap/nhom-quyen': 'nhomquyen',
  'thiet-lap/don-vi-do-luong': 'donvi',
  'chuyen-du-lieu': 'copydata',
  'van-hoa/don-vi': 'donvi',
  'van-hoa/thang-do': 'vanhoa_thangdovanhoa',
  'thiet-lap/gioi-han': 'gioihan',
  'role-group': 'nhomquyen',
  'role-approve': 'roleapprove',
  // Menu modulename = giaidoan (không có dấu gạch)
  'giai-doan': 'giaidoan',

  // Hướng dẫn — không map controller (menu không có modulename → mọi user đăng nhập xem được)
  // 'huong-dan' / 'van-hoa/huong-dan' cố ý bỏ khỏi map để Layout không chặn.

  // ==================== Thư viện KPIs ====================
  'kpi-chung': 'kpichung',
  'kpi-ngoai-le': 'ngoaile',
  'kpiipoo': 'kpiipoo',
  'thu-vien-kpi': 'thuvienkpi',
  'hieu-suat-kpi': 'hieusuatkpi',
  'kpi-cong-thuc': 'kpicongthuc',

  // ==================== Khác ====================
  'logfiles': 'logfiles',
  'van-hoa/logfiles': 'logfiles',
  'phuongdien': 'phuongdien',
  'bao-cao-viec-trong-ngay': 'bao-cao-viec-trong-ngay',
  'van-hoa/bao-cao-viec-trong-ngay': 'bao-cao-viec-trong-ngay',
  'van-hoa/ngoi-nha': 'vanhoa_ngoinha',
  'van-hoa/hanh-vi-then-chot': 'vanhoa_hanhvithenchot',
  'van-hoa/an-le': 'vanhoa_anle',
  'van-hoa/cau-hoi-an-le': 'vanhoa_cauhoianle',
  'van-hoa/dashboard': 'vanhoa_dashboard',
  'van-hoa/hinh-mau/tieu-chi/lanh-dao': 'vanhoa_hinhmau_tieuchi',
  'van-hoa/hinh-mau/lua-chon/lanh-dao': 'vanhoa_hinhmau_luachon',
  'van-hoa/hinh-mau/danh-gia': 'vanhoa_hinhmau_danhgia',
  'van-hoa/hinh-mau/danh-gia/lanh-dao': 'vanhoa_hinhmau_danhgia',
  /** Gắn kết – Trải nghiệm – Điểm chạm: map tới controller trong TREE_SELECT_ROUTES để header mount cây bộ phận. */
  'van-hoa/tieu-chi-nhan-vien/trai-nghiem-gan-ket-diem-cham': 'vanhoa_tieuchigankettrainghiemdiemcham',
  'van-hoa/admin/tieu-chi-van-hoa': 'vanhoa_tieuchitruongthanhvanhoa',
  'van-hoa/admin/tieu-chi-ganket-trainghiem-diemcham': 'vanhoa_tieuchigankettrainghiemdiemcham',
  'co-cau-giai-doan': 'co-cau-giai-doan',
  'co-cau-giai-doan/tai-co-cau': 'co-cau-giai-doan/tai-co-cau',
};

/**
 * Danh sách các route có params (cần xử lý đặc biệt)
 */
export const ROUTE_WITH_PARAMS: string[] = ['cong-viec-du-an', 'bao-cao-viec-trong-ngay'];

/**
 * Route BSC mọi user đăng nhập được mở (Roles không có controller tương ứng, dữ liệu BE tự lọc theo user).
 * Chỉ Layout dùng để bỏ chặn trang — getControllerFromRoute vẫn trả controller như cũ.
 */
export const PAGE_GUARD_EXEMPT_ROUTES: string[] = [
  'bang-ke-hoach',
  'tong-quan-cong-viec',
  'quan-ly-action-plan-bo-phan',
  'bao-cao-viec-trong-ngay',
  'huong-dan',
];

export const isPageGuardExemptRoute = (pathname: string): boolean => {
  const cleanPath = pathname.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');
  return PAGE_GUARD_EXEMPT_ROUTES.some((route) => cleanPath === route || cleanPath.startsWith(`${route}/`));
};

/**
 * Lấy controller từ route hiện tại
 * @param pathname - Current pathname
 * @returns Controller name hoặc null nếu không tìm thấy
 */
export const getControllerFromRoute = (pathname: string): string | null => {
  // Loại bỏ dấu / ở đầu
  const cleanPath = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  // Nếu pathname là root hoặc empty, trả về dashboard
  if (!cleanPath || cleanPath === '') {
    return ROUTE_TO_CONTROLLER_MAP[''] || '';
  }

  // Lấy segment đầu tiên của path
  const firstSegment = cleanPath.split('/')[0];

  // Kiểm tra xem segment đầu tiên có trong ROUTE_WITH_PARAMS không
  if (ROUTE_WITH_PARAMS.includes(firstSegment)) {
    // Logic cho route có params: dùng segment đầu tiên
    return ROUTE_TO_CONTROLLER_MAP[firstSegment] || null;
  }

  // Logic cho các route khác: exact match trước
  if (ROUTE_TO_CONTROLLER_MAP[cleanPath]) {
    return ROUTE_TO_CONTROLLER_MAP[cleanPath];
  }

  // Prefix match — ưu tiên route dài nhất (tránh van-hoa/dot-on-tap/* khớp nhầm dot-on-tap → dotontap BSC)
  let bestRoute = '';
  let bestController: string | null = null;
  for (const [route, controller] of Object.entries(ROUTE_TO_CONTROLLER_MAP)) {
    if (!route) continue;
    if (cleanPath === route || cleanPath.startsWith(`${route}/`)) {
      if (route.length > bestRoute.length) {
        bestRoute = route;
        bestController = controller;
      }
    }
  }
  if (bestController) {
    return bestController;
  }

  // Fallback: trả về segment đầu tiên
  return firstSegment;
};
